import React from "react";
import { Typography, Col, Row, Divider } from "antd";
import { template, setLocalStorage, resolveUrl, getDate } from "@reco-m/core";
import { ViewComponent, ImageAuto } from "@reco-w/core-ui";
import { homeModel, Namespaces } from "@reco-w/home-models";
import { BackTopBox } from "@reco-w/about-e";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs, EffectFade } from "swiper";
import { cooperationParkService } from "../service/park.service";
import { r2040ArticleService, EnumGroupHomeTag } from "src/apps/common/common";

SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs, EffectFade]);
const { Paragraph } = Typography;

declare class CountUp {
    constructor(...p: any[]);

    start(): void;
}

export namespace Home {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, homeModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.home;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", "/home"); // 设置被选中的菜单
        }

        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 0, customerSlides: 5, resourcesIndex: 1 });

            this.scalePage();

            $(window).resize(() => {
                return this.scalePage();
            });

            cooperationParkService.getList().then((d) => {
                this.dispatch("input", { cooperationPark: d });
            });

            r2040ArticleService.getPaged({
                pageSize: 5, inTagIds: [
                    EnumGroupHomeTag.xinwzx,
                    EnumGroupHomeTag.tongztg,
                    EnumGroupHomeTag.huodjj,
                ], isValid: true, orderBy: 'isTop,sequence,id desc'
            }).then(d => {
                this.dispatch("input", { articles: d.items });
            });

        }

        numberChange(e) {
            // 数字滚动
            let options = {
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                prefix: "",
                suffix: ""
            };
            let demo = new CountUp("num0", 0, 30, 0, 2.5, options);
            let demo2 = new CountUp("num1", 0, 1000, 0, 2.5, options);
            let demo3 = new CountUp("num2", 0, 2000, 0, 2.5, options);
            let demo4 = new CountUp("num3", 0, 346571, 0, 2.5, options);
            $(window).on("scroll", function () {
                if (($(window).scrollTop() as any) > e) {
                    demo.start();
                    demo2.start();
                    demo3.start();
                    demo4.start();
                }
            });
        }
        numberChange1(e) {
            // 数字滚动
            let options = {
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                prefix: "",
                suffix: ""
            };
            let demo = new CountUp("num0", 0, 30, 0, 2.5, options);
            let demo2 = new CountUp("num1", 0, 500, 0, 2.5, options);
            let demo3 = new CountUp("num2", 0, 2000, 0, 2.5, options);
            let demo4 = new CountUp("num3", 0, 346571, 0, 2.5, options);
            $(".container-scrollable").on("scroll", function () {
                if (($(".container-scrollable").scrollTop() as any) > e) {
                    demo.start();
                    demo2.start();
                    demo3.start();
                    demo4.start();
                }
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, customerSlides: 2 });
                this.numberChange1(1100)
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, customerSlides: 5 });
                this.numberChange(1150);
            }
        }

        renderBanner() {
            return (
                <div className="home-box home-banner-box">
                    <div className="loader_bg">
                        <div className="loader"></div>
                        <h4 className="loading-title">LOADING...</h4>
                    </div>
                    <div className="swiper-button-prev">
                        <i className="icon iconjiantou" />
                        <div>PREV</div>
                    </div>
                    <div className="swiper-button-next">
                        <i className="icon iconjiantou" />
                        <div>NEXT</div>
                    </div>
                    <Swiper
                        className="home-banner-swiper"
                        loop={true}
                        effect="fade"
                        navigation={{
                            nextEl: ".home-box .swiper-button-next",
                            prevEl: ".home-box .swiper-button-prev",
                        }}
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 6000,
                            disableOnInteraction: false,
                        }}
                        slidesPerView={1}
                    >
                        <SwiperSlide>
                            <img className="banner-img" src="assets/images/jtgw/banner-1.jpg" height="100%" width="100%" />
                            <div className="banner-video-word slide-fadeIn delay-1s">
                                <div className="word1">产业园区科技服务商</div>
                                <div className="word2">聚焦数字经济，助力数字产业化+产业数字化</div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="banner-img" src="assets/images/jtgw/banner-3.png" height="100%" width="100%" />
                            <div className="banner-video-word slide-fadeIn delay-1s">
                                <div className="word1">聚焦产业园区数字化赛道</div>
                                <div className="word2">以科技助力产业园区破局，构建数字化发展新范式</div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="banner-img" src="assets/images/jtgw/banner-2.jpg" height="100%" width="100%" />
                            <div className="banner-video-word slide-fadeIn delay-1s">
                                <div className="word1">产业园区一站式招商运营服务</div>
                                <div className="word2">政府和企业产业服务全方位合作伙伴</div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            );
        }

        /*renderBanner1() {
            return (
                <div className="banner-video">
                    <video src="assets/video/banner.mp4" width="100%" height="100%" muted loop={true} autoPlay={true} poster="assets/video/fm.jpg" />
                    <div className="banner-video-word animated zoomIn">
                        <div className="word1">产业园区科技服务商</div>
                        <div className="word2">聚焦数字经济，助力数字产业化+产业数字化</div>
                    </div>
                    <Row className="banner-video-sz" justify="space-between">
                        <div className="banner-video-number">
                            <div className="number">
                                <span id="num0">30</span>+
                            </div>
                            <div className="size-30 white-color">城市</div>
                        </div>
                        <div className="banner-video-number">
                            <div className="number">
                                <span id="num1">500</span>+
                            </div>
                            <div className="size-30 white-color">政府园区</div>
                        </div>
                        <div className="banner-video-number">
                            <div className="number">
                                <span id="num2">2000</span>+KM²
                            </div>
                            <div className="size-30 white-color">覆盖区域</div>
                        </div>
                        <div className="banner-video-number">
                            <div className="number">
                                <span id="num3">346571</span>+
                            </div>
                            <div className="size-30 white-color">服务企业</div>
                        </div>
                    </Row>
                </div>
            );
        }*/

        renderService() {
            const data = [
                [
                    {
                        icon: "recogroup-icon-1",
                        text: "营商服务",
                    },
                    {
                        icon: "recogroup-icon-2",
                        text: "智慧运营",
                    },
                    {
                        icon: "recogroup-icon-7",
                        text: "数智决策",
                    },
                    {
                        icon: "recogroup-icon-8",
                        text: "产业大脑",
                    },
                    {
                        icon: "recogroup-icon-13",
                        text: "AIOT",
                    },
                    {
                        icon: "recogroup-icon-14",
                        text: "数字基座",
                    },
                ],
                [
                    {
                        icon: "recogroup-icon-3",
                        text: "大企业开放创新中心",
                    },
                    {
                        icon: "recogroup-icon-4",
                        text: "孵化器/创新中心",
                    },
                    {
                        icon: "recogroup-icon-9",
                        text: "域外产创基地",
                    },
                    {
                        icon: "recogroup-icon-10",
                        text: "双招双引人才基地",
                    },
                    {
                        icon: "recogroup-icon-15",
                        text: "空间资产联合运营",
                    },
                    {
                        icon: "recogroup-pinpai",
                        text: "品牌影响力打造",
                    },
                ],
                [
                    {
                        icon: "recogroup-icon-5",
                        text: "产业招商",
                    },
                    {
                        icon: "recogroup-icon-6",
                        text: "企业选址",
                    },
                    {
                        icon: "recogroup-icon-11",
                        text: "企业上云",
                    },
                    {
                        icon: "recogroup-icon-12",
                        text: "招商大数据",
                    },
                    {
                        icon: "recogroup-icon-17",
                        text: "招商推介会",
                    },
                    {
                        icon: "recogroup-icon-18",
                        text: "选址服务日",
                    },
                ],
            ];
            return (
                <div className="home-service-content layout-content">
                    <div className="container large-container">
                        <div className="home-title text-center pb10">
                            <div className="new-home-title">我们正在<span className="primary-color">布局</span></div>
                        </div>
                        <Row gutter={{ xs: 15, md: 15, xl: 30 }} className="layout-box">
                            <Col xs={24} sm={24} md={8} xl={8}>
                                <div className='layout-line-block'>
                                    <div className="size-26 text-center">瑞谷软件</div>
                                    <Row gutter={{ xs: 15, md: 15, xl: 25 }} className="mt25">
                                        {data[0].map((item, i) => {
                                            return (
                                                <Col span={12} key={i}>
                                                    <div className="bj-card" onClick={() => this.goTo("/software")}>
                                                        <div>
                                                            <i className={this.classnames("recogroup size-40", item.icon)}></i>
                                                            <div className="bj-card-text">{item.text}</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8} xl={8}>
                                <div className='layout-line-block'>
                                    <div className="size-26 text-center">瑞谷科创</div>
                                    <Row gutter={{ xs: 15, md: 15, xl: 25 }} className="mt25">
                                        {data[1].map((item, i) => {
                                            return (
                                                <Col span={12} key={i}>
                                                    <div className="bj-card" onClick={() => this.goTo("/scientific")}>
                                                        <div>
                                                            <i className={this.classnames("recogroup size-40", item.icon)}></i>
                                                            <div className="bj-card-text">{item.text}</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8} xl={8}>
                                <div className='layout-line-block'>
                                    <div className="size-26 text-center">瑞谷云企</div>
                                    <Row gutter={{ xs: 15, md: 15, xl: 25 }} className="mt25">
                                        {data[2].map((item, i) => {
                                            return (
                                                <Col span={12} key={i}>
                                                    <div className="bj-card" onClick={() => this.goTo("/yunqi")}>
                                                        <div>
                                                            <i className={this.classnames("recogroup size-40", item.icon)}></i>
                                                            <div className="bj-card-text">{item.text}</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }


        renderPark() {
            const { state } = this.props,
                cooperationPark = state!.cooperationPark || [];
            // if (!cooperationPark.length) return <></>;

            const data = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"];

            return (
                <div className="pt30 pb30 park-content">
                    <div className="container large-container">
                        <div className="home-title text-center pv50">
                            <div className="new-home-title">我们正在<span className="primary-color">前行</span></div>
                        </div>
                        <Row justify="space-between" className="forward">
                            <div className="banner-video-number">
                                <div className="text">城市</div>
                                <div className="number">
                                    <span id="num0">30</span>+
                                </div>
                            </div>
                            <div className="banner-video-number">
                                <div className="text ">政府园区</div>
                                <div className="number">
                                    <span id="num1">1000</span>+
                                </div>
                            </div>
                            <div className="banner-video-number">
                                <div className="text ">覆盖区域</div>
                                <div className="number">
                                    <span id="num2">2000</span>+<span className="size-28">KM²</span>
                                </div>
                            </div>
                            <div className="banner-video-number">
                                <div className="text ">服务企业</div>
                                <div className="number">
                                    <span id="num3">346571</span>+
                                </div>
                            </div>
                        </Row>
                        <Row gutter={{ md: 40, xl: 80 }} align={"middle"} className='map-row'>
                            <Col xs={24} sm={24} md={7} xl={8}>
                                <div className="high-client">
                                    <div className="high-client-title">标杆客户</div>
                                    <Row gutter={{xs:10, sm:20}} className="bg-row high-row-list">
                                        {data.map((item, i) => {
                                            return (
                                                <Col xs={5} sm={8} key={i}>
                                                    <div className="high-row-item">
                                                        <img src={`assets/images/guanw/pole-logo${item}.png`} />
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={17} xl={16}>
                                <div className="custom-scoll">
                                    <div className="home-map">
                                        {cooperationPark && cooperationPark.map((x, i) => (
                                            <div className="region-list " style={{ left: x.left + "px", top: x.top + "px" }} key={i}>
                                                <div className="area-box">
                                                    <span className="dot" />
                                                    <span className="pulse delay-01" />
                                                    <span className="pulse delay-02" />
                                                </div>
                                                <div className="show-regin">
                                                    <span>{x.title}</span>
                                                    {/* <div className="map-desc">
                                                        <div className="size-16 white-color">{x.title}</div>
                                                        {x.address.split(",").map((g, i) => (
                                                            <div key={i} className="mt10">
                                                                {g}
                                                            </div>
                                                        ))}
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }

        goToDetail(item) {
            if (item.contentType == 1) {
                this.goTo(`/information/details/${item.id}`);
            } else if (item.contentType == 2) {
                window.open(item.content);
            }
        }

        renderDynamic() {
            const { articles = [] } = this.props.state as any;
            if (!articles.length) return <></>;

            return (
                <div className="pt20 pb70 dynamic-content">
                    <div className="container large-container">
                        <div className="home-title text-center pv40">
                            <div className="new-home-title">新闻<span className="primary-color">动态</span></div>
                        </div>
                        <div className="desc-link">
                            <a onClick={() => {
                                this.goTo('/information/?pi=1&ps=6&t=1080412644754591744')
                            }}>新闻资讯</a>
                            <Divider type={"vertical"} />
                            <a onClick={() => {
                                this.goTo('/information/?pi=1&ps=6&t=1080412677361111040')
                            }}>通知通告</a>
                            <Divider type={"vertical"} />
                            <a onClick={() => {
                                this.goTo('/information/?pi=1&ps=6&t=1080412761108779008')
                            }}>活动集锦</a>{" "}
                        </div>
                        <Row gutter={20}>
                            <Col xs={24} sm={24} md={8}>
                                <Swiper
                                    slidesPerView={1}
                                    className="dynamic-swiper"
                                    style={{ height: 420 }}
                                    pagination={true}
                                    loop={true}
                                    autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false, //false: 鼠标操作屏幕后继续自动滚屏
                                    }}
                                >
                                    {articles.map((item, i) => {
                                        return (
                                            <SwiperSlide key={i}>
                                                <div className="dynamic-swiper-item" onClick={() => {
                                                    this.goToDetail(item);
                                                }}>
                                                    <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="100%" radius={0} />
                                                    <Paragraph ellipsis className="mb0 dynamic-swiper-title">
                                                        {item.title}
                                                    </Paragraph>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <div className="dynamic-item">
                                    <Paragraph ellipsis className="size-18 mb0">
                                        {articles[0].title}
                                    </Paragraph>
                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="size-14 gray-tow-color mb0 mt5">
                                        {articles[0].summary}
                                    </Paragraph>
                                    <Row className="gray-three-color lineHeigh12 border-top mt16 pt13" align="middle" onClick={() => {
                                        this.goToDetail(articles[0]);
                                    }}>
                                        <Col span={18}>
                                            <div className="size-30">{getDate(articles[0].publishTime)?.format('dd')}</div>
                                            <div className="size-14">{getDate(articles[0].publishTime)?.format('yyyy.MM')}</div>
                                        </Col>
                                        <Col span={6} className="text-right">
                                            <i className="icon iconjiantou1 size-30 gray-four-color" />
                                        </Col>
                                    </Row>
                                </div>
                                {articles.length > 1 && <div className="dynamic-item mt20" onClick={() => {
                                    this.goToDetail(articles[1]);
                                }}>
                                    <Paragraph ellipsis className="size-18 mb0">
                                        {articles[1].title}
                                    </Paragraph>
                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="size-14 gray-tow-color mb0 mt5">
                                        {articles[1].summary}
                                    </Paragraph>
                                    <Row className="gray-three-color lineHeigh12 border-top mt16 pt13" align="middle">
                                        <Col span={18}>
                                            <div className="size-30">{getDate(articles[1].publishTime)?.format('dd')}</div>
                                            <div className="size-14">{getDate(articles[1].publishTime)?.format('yyyy.MM')}</div>
                                        </Col>
                                        <Col span={6} className="text-right">
                                            <i className="icon iconjiantou1 size-30 gray-four-color" />
                                        </Col>
                                    </Row>
                                </div>}
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                {[2, 3, 4].map((idx, i) => {
                                    return articles.length > idx ? <div key={i} className={"dynamic-item small " + (idx >= 3 ? ' mt20' : '')} onClick={() => {
                                        this.goToDetail(articles[idx]);
                                    }}>
                                        <Row gutter={40} align="middle">
                                            <Col span={7}>
                                                <div className="gray-three-color lineHeigh12">
                                                    <div className="size-30">{getDate(articles[idx].publishTime)?.format('dd')}</div>
                                                    <Divider className="mv5" style={{ width: 20, minWidth: 0 }} />
                                                    <div className="size-14">{getDate(articles[idx].publishTime)?.format('yyyy.MM')}</div>
                                                </div>
                                            </Col>
                                            <Col span={17} className="border-left">
                                                <Paragraph ellipsis={{ rows: 2, expandable: false }} className="size-16 mb0">
                                                    {articles[idx].title}
                                                </Paragraph>
                                                <div className="mt11">
                                                    <i className="icon iconyou gray-four-color" />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div> : <></>;
                                })}
                            </Col>
                        </Row>
                    </div>
                </div>
            );
        }

        renderBody(): React.ReactNode {
            return (
                <>
                    <div className="home-body">
                        {/*{this.renderBanner1()}*/}
                        {this.renderBanner()}
                        {this.renderService()}
                        {this.renderPark()}
                        {this.renderDynamic()}
                    </div>
                    {this.renderEmbeddedView(BackTopBox.Page)}
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.home]);
}
